
import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ytd-weekly-average-dt',
  templateUrl: './ytd-weekly-average-dt.component.html',
  styleUrls: ['./ytd-weekly-average-dt.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class YtdWeeklyAverageDtComponent {
  @Input() dashboardData: any;
  ytdWeeklySales: any = 0;
  ytdWeeklyOrdersItems: string = '';
  ytdWeeklySalesValuePerItem: string = '0';
  ytdWeeklyAverageOrder: string = '0';
  ytdWeeklySushiSales: any = 0;
  ytdWeeklySushiItemsSold: any = 0;
  ytdWeeklyBentoSales: any = 0;
  ytdWeeklyBentoItemsSold: any = 0;
  ytdWeeklyCommonSales: any = 0;
  ytdWeeklyCommonItemsSold: any = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      const dashBoardData = this.dashboardData?.dt_dashboard_data;
      // TOTAL SALES
      this.ytdWeeklySales = this.setDecimalPoints(this.fnCheckNull(dashBoardData?.ytd_weekly_sales));

      // TOTAL ORDERS / ITEMS
      let ytdWeeklyItemsSold = this.fnCheckNull(dashBoardData?.ytd_weekly_items_sold);
      ytdWeeklyItemsSold = this.setDecimalPoints(ytdWeeklyItemsSold, 0);

      let ytdWeeklyNoOfCustOrders = this.fnCheckNull(dashBoardData?.ytd_weekly_no_of_cust_orders);
      ytdWeeklyNoOfCustOrders = this.setDecimalPoints(ytdWeeklyNoOfCustOrders, 0);

      this.ytdWeeklyOrdersItems = `${ytdWeeklyNoOfCustOrders.toLocaleString('en-US', { maximumFractionDigits: 0 })} / ${ytdWeeklyItemsSold.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

      // SALES VALUE / ITEM
      if (ytdWeeklyItemsSold > 0) {
        let weeklyAvgSalesValueByItem = this.ytdWeeklySales / ytdWeeklyItemsSold;
        weeklyAvgSalesValueByItem = this.setDecimalPoints(weeklyAvgSalesValueByItem, 2);
        this.ytdWeeklySalesValuePerItem = weeklyAvgSalesValueByItem.toFixed(2);
      } else {
        this.ytdWeeklySalesValuePerItem = '0';
      }

      // AVERAGE ORDER $
      if (ytdWeeklyNoOfCustOrders > 0) {
        let ytdWeekAverageOrder = this.ytdWeeklySales / ytdWeeklyNoOfCustOrders;
        ytdWeekAverageOrder = this.setDecimalPoints(ytdWeekAverageOrder, 2);
        this.ytdWeeklyAverageOrder = ytdWeekAverageOrder.toFixed(2);
      } else {
        this.ytdWeeklyAverageOrder = '0';
      }

      // SUSHI SALES
      let ytdWeeklySushiSales = this.fnCheckNull(dashBoardData?.ytd_weekly_avg_dt_sushi_sales);
      ytdWeeklySushiSales = this.setDecimalPoints(ytdWeeklySushiSales);
      this.ytdWeeklySushiSales = ytdWeeklySushiSales;

      // SUSHI ITEM SOLD
      let ytdWeeklySushiItemsSold = this.fnCheckNull(dashBoardData?.ytd_weekly_avg_dt_sushi_item_sold);
      ytdWeeklySushiItemsSold = this.setDecimalPoints(ytdWeeklySushiItemsSold, 0);
      this.ytdWeeklySushiItemsSold = ytdWeeklySushiItemsSold;

      // BENTO SALES
      let ytdWeeklyBentoSales = this.fnCheckNull(dashBoardData?.ytd_weekly_avg_dt_bento_sales);
      ytdWeeklyBentoSales = this.setDecimalPoints(ytdWeeklyBentoSales);
      this.ytdWeeklyBentoSales = ytdWeeklyBentoSales;

      // BENTO ITEM SOLD
      let ytdWeeklyBentoItemsSold = this.fnCheckNull(dashBoardData?.ytd_weekly_avg_dt_bento_item_sold);
      ytdWeeklyBentoItemsSold = this.setDecimalPoints(ytdWeeklyBentoItemsSold, 0);
      this.ytdWeeklyBentoItemsSold = ytdWeeklyBentoItemsSold;

      // COMMON SALES
      let ytdWeeklyCommonSales = this.fnCheckNull(dashBoardData?.ytd_weekly_avg_dt_common_sales);
      ytdWeeklyCommonSales = this.setDecimalPoints(ytdWeeklyCommonSales);
      this.ytdWeeklyCommonSales = ytdWeeklyCommonSales;

      // COMMON ITEM SOLD
      let ytdWeeklyCommonItemsSold = this.fnCheckNull(dashBoardData?.ytd_weekly_avg_dt_common_item_sold);
      ytdWeeklyCommonItemsSold = this.setDecimalPoints(ytdWeeklyCommonItemsSold, 0);
      this.ytdWeeklyCommonItemsSold = ytdWeeklyCommonItemsSold;
    }
  }

  setDecimalPoints(value: number, decimal: number = 1): number {
    return Number(Number(value).toFixed(decimal));
  }

  fnCheckNull(a: any): number {
    return a == null ? 0 : a;
  }

}
